/**
 * English Localization Resources
 */
export default {
  layout: {
    brand: 'CardShop Kiosk',
    loading: 'Loading, please wait...',
    offline: 'Network connection lost',
  },
  error: {
    network: 'Network connection failed, please check your settings',
    unknown: 'An unknown error occurred, please contact staff',
    maintenance: 'System under maintenance, please wait',
  },
  common: {
    btn: {
      confirm: 'Confirm',
      cancel: 'Cancel',
      retry: 'Retry',
      copy: 'Copy',
    },
  },
  home: {
    welcome: 'Welcome to CardShop Kiosk',
    start: 'Start / 开始购卡',
    startAria: 'Click to start buying cards',
    allCategories: 'All',
  },
  products: {
    title: 'Select Product / 选择商品',
    back: 'Back',
    lowStock: 'Low Stock',
    outOfStock: 'Out of Stock',
    empty: 'No products available',
    loading: 'Loading products...',
    createOrderFailed: 'Failed to create order, please try again',
    activeOrderExists: 'You have an unfinished order, please complete it or wait for it to expire',
    activeOrderExistsRedirecting: 'Active order detected, redirecting...',
  },
  order: {
    title: 'Order Detail / 订单详情',
    back: 'Back',
    payNow: 'Pay Now / 去支付',
    cancel: 'Cancel / 取消订单',
    notFound: 'Order not found, please place a new order',
    cancelComingSoon: 'Order cancellation will be implemented in the next phase',
    status: {
      PENDING: 'Pending',
      IN_PAY: 'Paying',
      PAYING: 'Paying',
      PAID: 'Paid',
      DELIVERING: 'Delivering',
      COMPLETED: 'Completed',
      FAILED: 'Failed',
      CANCELLED: 'Cancelled',
      CANCELED: 'Cancelled',
      FULFILLED: 'Delivered',
      TIMEOUT: 'Timed Out',
      REFUNDING: 'Refunding',
      REFUNDED: 'Refunded',
    },
    statusLoading: 'Loading…',
    paidAt: 'Payment Time',
    createdAt: 'Creation Time',
    unitPrice: 'Unit Price',
    paidAmount: 'Paid Amount',
    statusLabel: 'Status',
    cardNumber: 'Card Number',
    cardKey: 'Card Key',
    invoice: 'Invoice',
    invoiceNo: 'Invoice No.',
    invoiceIssued: 'Issued',
    invoiceApply: 'Request Invoice',
    invoiceApplyTitle: 'Request E-Invoice',
    invoiceCarrierType: 'Carrier Type',
    invoiceCarrierNone: 'None (Cloud Storage)',
    invoiceCarrierMobile: 'Mobile Barcode',
    invoiceCarrierCDC: 'Carrier Number',
    invoiceCarrierEZ: 'EasyCard / icash',
    invoiceCarrierEmail: 'Email',
    invoiceCarrierDonation: 'Donate Invoice',
    invoiceCarrierId: 'Carrier ID',
    invoiceCarrierIdPlaceholder: 'Enter carrier ID',
    invoiceEmail: 'Email',
    invoiceEmailPlaceholder: 'Enter email address',
    invoiceDonationHint: 'Invoice will be donated to Eden Social Welfare Foundation (Code: 25885)',
    invoiceSubmit: 'Submit',
    invoiceSubmitting: 'Submitting...',
    invoiceSuccess: 'Invoice requested! Invoice No.: {no}',
    invoiceSuccessDonation: 'Thank you for your donation! Invoice donated to Eden Social Welfare Foundation',
    invoiceFailed: 'Failed to request invoice, please retry',
    invoiceDuplicate: 'An invoice has already been issued for this order',
    invoiceAutoSubmit: 'Donate & Close ({seconds}s)',
    invoiceAutoSubmitDone: 'Invoice auto-donated',
    processSteps: 'Subsequent Process Steps',
    redeemInfo: 'Redemption Info',
    processing: 'Processing...',
    loadingPayload: 'Retrieving card number/key, please wait…',
    retryPayload: 'Retry fetching card info',
    payloadLoaded: 'Card info retrieved',
    payloadFailed: 'Failed to retrieve card info, please retry',
    copySuccess: 'Copied to clipboard',
    copyFailed: 'Copy failed, please copy manually',
    sendCardEmail: 'Send Card Key to Email',
    sendCardEmailTitle: 'Send Card Key to Email',
    sendCardEmailHint: 'Card number and key will be sent to your email address. Please ensure it is correct.',
    sendCardEmailInput: 'Enter email address',
    sendCardEmailSubmit: 'Send',
    sendCardEmailSending: 'Sending...',
    sendCardEmailSuccess: 'Card key sent! Please check your email.',
    sendCardEmailFailed: 'Failed to send. Please try again.',
    qrVerifyTitle: 'Verification QR Code',
    qrVerifyHint: 'Merchants can scan to verify if this card has been issued by the machine',
    qrVerifyLoading: 'Generating QR code…',
    qrVerifyRetry: 'Retry QR code',
    customerContact: 'Customer Support',
    customerContactNone: 'Please contact staff if you need assistance',
    customerContactTitle: 'Contact Support',
    customerContactClose: 'Close',
  },
  ad: {
    exitTip: 'Touch screen to exit',
  },
  // ── E.3-2 maintenance ─────────────────────────────────────────────────────
  maintenance: {
    title: 'Under Maintenance / 设备维护中',
    retry: 'Retry Connection',
    network_offline: 'Network connection lost. Please check your network.',
    auth_failed: 'Device authentication failed. Please contact support.',
    machine_locked: 'Device has been remotely locked.',
    dtu_offline: 'Card dispenser is offline. Waiting for recovery.',
    unknown: 'An unknown system error has occurred.',
    reconnecting: 'Attempting to reconnect…',
    wsStatus: 'WS Connection Status',
    networkOnline: 'Network Online',
    networkOffline: 'Network Offline',
    contactTitle: 'Contact Support',
    contactPhoneLabel: 'Hotline',
    contactPhone: '400-888-0000',
    contactWechat: '@cardshop_support',
    workOrder: 'Submit ticket: support.cardshop.com',
  },
  // ── E.3-2 pay ─────────────────────────────────────────────────────────────
  pay: {
    title: 'Payment / 支付',
    summary: 'Order Summary',
    orderPayment: 'Order Payment',
    method: 'Payment Method',
    cash: 'Cash',
    linepay: 'LinePay',
    card: 'Credit Card',
    applepay: 'Apple Pay',
    comingSoon: 'This payment method is coming soon',
    insertBill: 'Please insert bills',
    remaining: 'Remaining',
    completed: 'Payment Completed!',
    cancelled: 'Payment Cancelled',
    billReceived: 'Received {amount}',
    billInsertedFull: 'Inserted {inserted}',
    billInsertedStatus: 'Inserted {inserted}, remaining {remaining}',
    contactSupport: 'Contact Support',
    cancelOrder: 'Cancel Order',
    timeout: 'Inactivity timeout, please complete payment soon',
    orderNotFound: 'Order not found, please place a new order',
    fullyPaidRedirect: 'Payment completed, redirecting…',
    // ── F.12 新增：找零 / 拒钞 / 超时 ──────────────────────────────────────
    change: {
      label: 'Please take your change {amount}',
    },
    billRejected: 'Machine temporarily unable to read bill. Please try again. Contact staff if issue persists.',
    billTimeout: 'Payment timeout, order cancelled automatically',
    countdown: 'Please insert bills within {time}. Order will be cancelled upon timeout.',
    countdownExpired: 'Order has timed out. Please place a new order.',
  },
  // ── E.3-2 toast ───────────────────────────────────────────────────────────
  toast: {
    dismiss: 'Dismiss',
  },
  header: {
    online: 'Online',
    offline: 'Offline',
    reconnecting: 'Reconnecting',
  },
  footer: {
    online: 'Network OK',
    offline: 'Network Down',
    reconnecting: 'Network Reconnecting',
  },
}
